export const queryOptions = {};
